<template>
  <validation-observer ref="colorSampleObserver" class="color-sample-checkout">
    <div class="row">
      <div class="col col-12 col-md-6">
        <validation-provider rules="required" v-slot="{ errors,touched }">
          <input type="text" name="billing_name" v-model="data.billing_name"
                 :placeholder="trans('sample_order_name')+'*'" :class="getInputClass(errors,touched)"/>
        </validation-provider>
      </div>
      <div class="col col-12 col-md-6">
        <validation-provider rules="required" v-slot="{ errors,touched }">
          <input type="text" name="billing_address" v-model="data.billing_address"
                 :placeholder="trans('sample_order_street_and_house_number')+'*'"
                 :class="getInputClass(errors,touched)"/>
        </validation-provider>
      </div>
    </div>
    <div class="row">
      <div class="col col-12 col-md-6">
        <validation-provider rules="required" v-slot="{ errors,touched }">
          <input type="text" name="billing_city" v-model="data.billing_city"
                 :placeholder="trans('sample_order_city')+'*'" :class="getInputClass(errors,touched)"/>
        </validation-provider>
      </div>
      <div class="col col-12 col-md-6">
        <validation-provider rules="required" v-slot="{ errors,touched }">
          <input type="text" name="billing_zip" v-model="data.billing_zip"
                 :placeholder="trans('sample_order_zip_code')+'*'" :class="getInputClass(errors,touched)"/>
        </validation-provider>
      </div>
    </div>
    <div class="row">
      <div class="col col-12 col-md-6">
        <validation-provider rules="required|email" v-slot="{ errors,touched }">
          <input type="text" name="billing_email" v-model="data.billing_email"
                 :placeholder="trans('sample_order_email')+'*'" :class="getInputClass(errors,touched)"/>
        </validation-provider>
      </div>
      <div class="col col-12 col-md-6">
        <validation-provider :rules="{ regex: phoneRegex, required:true }"
                             v-slot="{ errors,touched }">
          <input type="tel" name="billing_phone" v-model="data.billing_phone"
                 voff-mask="[...masks]"
                 @keydown="phoneKeyPress"
                 :placeholder="trans('sample_order_phone')+'*'" :class="getInputClass(errors,touched)"/>
        </validation-provider>
      </div>
    </div>
    <div class="row">
      <div class="col col-12 col-md-6">
        <input falsetype="text" name="billing_company_name" v-model="data.billing_company_name"
               :placeholder="trans('sample_order_company_name')" class="color-sample-input"/>
      </div>
      <div class="col col-12 col-md-6">
        <input type="text" name="billing_vat_number" v-model="data.billing_vat_number"
               :placeholder="trans('sample_order_vat_number')" class="color-sample-input"/>
      </div>
    </div>
    <div class="row">
      <div class="col col-12 col-md-6 color-order-billing-radio-container">
        <div class="radio-buttons">
          <div class="radio-button">
            <input type="radio" id="same_address"
                   name="same_address"
                   :value="true"
                   v-model="sameAddress"
                   checked="true">
            <label for="same_address">
              <span></span>{{ trans('sample_order_delivery_same_billing') }}
            </label>
          </div>
        </div>
      </div>
      <div class="col col-12 col-md-6 color-order-billing-radio-container">

        <div class="radio-buttons">
          <div class="radio-button">
            <input type="radio" id="same_address_1"
                   name="same_address"
                   :value="false"
                   v-model="sameAddress"
                   checked="false">
            <label for="same_address_1">
              <span></span>{{ trans('sample_order_delivery_different_billing') }}
            </label>
          </div>
        </div>
      </div>
    </div>
    <template v-if="!sameAddress">
      <div class="row">
        <div class="col col-12 col-md-6">
          <validation-provider rules="required" v-slot="{ errors,touched }">
            <input type="text" name="name" v-model="data.name" :placeholder="trans('sample_order_name')+'*'"
                   :class="getInputClass(errors,touched)"/>
          </validation-provider>
        </div>
        <div class="col col-12 col-md-6">
          <validation-provider rules="required" v-slot="{ errors,touched }">
            <input type="text" name="address" v-model="data.address"
                   :placeholder="trans('sample_order_street_and_house_number')+'*'"
                   :class="getInputClass(errors,touched)"/>
          </validation-provider>
        </div>
      </div>
      <div class="row">
        <div class="col col-12 col-md-6">
          <validation-provider rules="required" v-slot="{ errors,touched }">
            <input type="text" name="city" v-model="data.city" :placeholder="trans('sample_order_city')+'*'"
                   :class="getInputClass(errors,touched)"/>
          </validation-provider>
        </div>
        <div class="col col-12 col-md-6">
          <validation-provider rules="required" v-slot="{ errors,touched }">
            <input type="text" name="zip" v-model="data.zip" :placeholder="trans('sample_order_zip_code')+'*'"
                   :class="getInputClass(errors,touched)"/>
          </validation-provider>
        </div>
      </div>
      <div class="row">
        <div class="col col-12 col-md-6">
          <validation-provider rules="required|email" v-slot="{ errors,touched }">
            <input type="text" name="email" v-model="data.email" :placeholder="trans('sample_order_email')+'*'"
                   :class="getInputClass(errors,touched)"/>
          </validation-provider>
        </div>
        <div class="col col-12 col-md-6">
          <validation-provider :rules="{ regex: phoneRegex, required:true }"
                               v-slot="{ errors,touched }">
            <input type="text" name="phone" v-model="data.phone" :placeholder="trans('sample_order_phone')+'*'"
                   voff-mask="[...masks]"
                   @keydown="phoneKeyPress"
                   :class="getInputClass(errors,touched)"/>
          </validation-provider>
        </div>
      </div>
      <div class="row">
        <div class="col col-12 col-md-6">
          <input type="text" name="company_name" v-model="data.company_name"
                 :placeholder="trans('sample_order_company_name')" class="color-sample-input"/>
        </div>
        <div class="col col-12 col-md-6">
          
        </div>
      </div>
    </template>
    <div class="row checkboxGroup mt-3">
      <div class="checkbox-buttons">
        <validation-provider rules="required" v-slot="{ errors,touched }">
          <label :class="getLabelClass(errors,touched)">
            <input type="checkbox" id="checkbox_1" name="checkbox_1" value="checked" v-model="data.checkbox_1"
                   :class="['form-check-input checkbox']" @change="onCheckboxChange1">
            <span class="mdi mdi-name check-span"></span>
            <span class="checkbox-text mb-2" v-html="trans('sample_order_privacy_policy')"></span>
          </label>
        </validation-provider>
      </div>
    </div>
    <div class="row checkboxGroup">
      <div class="checkbox-buttons">
        <validation-provider rules="required" v-slot="{ errors,touched }">
          <label  :class="getLabelClass(errors,touched)">
            <input type="checkbox" id="checkbox_2" name="checkbox_2" value="checked" v-model="data.checkbox_2"
                   :class="['form-check-input checkbox']" @change="onCheckboxChange2">
            <span class="mdi mdi-name check-span"></span>
            <span class="checkbox-text mb-4" v-html="trans('sample_order_data_handling')"></span>
          </label>
        </validation-provider>
      </div>
    </div>
    <div class="row mt-5 mb-5">
      <div class="col-6">
        <button type="button" class="button type-15 sample-order-checkout-back-button" @click="goBack">
          <i class="material-icons">keyboard_backspace</i>
          {{ trans('calc_navigation_back') }}
        </button>
      </div>
      <div class="col-6 text-right">
        <button type="button" :class="'sample_order_next_button button type-1 '+forwardclass" @click="goForward">
          {{ trans('general_next') }}
        </button>
      </div>
    </div>
    <div class="row" v-if="false">
      <span class="color-order-basket-title mb-3">{{ trans('sample_order_in_your_basket') }}:</span>
      <color-sample-overview :canModifyQuantity="false" :canModifyStructure="false" :items="items"
                             :currency="currency"/>
    </div>
  </validation-observer>
</template>

<script>
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import ColorSampleOverview from './ColorSampleOverview';
import {translate} from "../service/translation";

export default {
  components: {
    ColorSampleOverview,
    ValidationProvider,
    ValidationObserver
  },
  props: {
    items: {
      required: true,
      type: Array
    },
    currency: {
      required: true,
      type: String
    },
    showValidate: {
      required: true,
      type: Boolean
    },
    forwardclass: {
      required: false,
      type: String,
      default: '',
    }
  },
  data() {
    return {
      isValid: false,
      sameAddress: true,
      //ki van kapcsolva felül voff-mask :)
      masks: ["+## ##########",],
      phoneRegex : window.sampleOrderPhoneRegex != 0 ? window.sampleOrderPhoneRegex : /^(\+\d{1,3})?(?:[0-9] ?-?){6,14}[0-9]$/,
      data: {
        name: '',
        company_name: '',
        city: '',
        zip: '',
        address: '',
        email: '',
        phone: '',
        billing_name: '',
        billing_company_name: '',
        billing_city: '',
        billing_zip: '',
        billing_address: '',
        billing_vat_number: '',
        billing_email: '',
        billing_phone: '',
        checkbox_1: '',
        checkbox_2: ''
      }
    }
  },
  methods: {
    goBack() {
      this.$emit('back');
    },
    goForward() {
      window.$('.sample-order-app-container input').each(function () {
        window.$(this).focus().blur();
      });
      this.$emit('forward');
    },
    getInputClass(errors, touched) {
      return 'color-sample-input' + (errors.length > 0 && touched ? ' color-sample-input-error' : '');
    },
    getLabelClass(errors, touched) {
      return 'form-check-label' + (errors.length > 0 && touched ? ' error' : '');
    },
    phoneKeyPress(e){
      let keyCode = e.which ? e.which : e.keyCode
      let originalKey = e.key ? e.key : '';
      let key = e.key ? parseInt(e.key) : -1;
        
      let isValid = 
        //0-9 közti számjegy numpadon
        (keyCode >= 96 && keyCode <= 105) || 
        //0-9 számjegy billentyűk
        (keyCode >= 48 && keyCode <= 57) || 
        //számjegy értékek
        (key >= 0 && key <= 9) ||
        //backspace vagy delete billentyű
        (keyCode == 46 || keyCode == 8 || originalKey == 'Delete' || originalKey == 'Backspace' ) || 
        // jobbra-balra nyilak
        (keyCode == 37 || keyCode == 39 || originalKey == 'ArrowLeft' || originalKey == 'ArrowRight' )
        ;
      //+ jel csak az elején lehet:
      if((keyCode == 107 || originalKey == '+')){
        isValid = window.$(e.target).val().length == 0;
      }
      //kötőjelek és space nem lehet az elején
      if((keyCode == 109 || keyCode == 173 || originalKey == '-' ) || (keyCode == 32 || originalKey == ' ' )){
        isValid = window.$(e.target).val().length > 0;
      }
      if(!isValid){
        e.preventDefault();
      }
      return isValid;
    },
    async validate() {
      this.isValid = await this.$refs.colorSampleObserver.validate();
      if (this.isValid && this.sameAddress) {
        this.data.name = this.data.billing_name;
        this.data.company_name = this.data.billing_company_name;
        this.data.city = this.data.billing_city;
        this.data.zip = this.data.billing_zip;
        this.data.address = this.data.billing_address;
        this.data.email = this.data.billing_email;
        this.data.phone = this.data.billing_phone;
      }
      this.$emit('customerData', this.isValid ? this.data : null);
    },
    onCheckboxChange1(event) {
      if (!event.target.checked) {
        this.data.checkbox_1 = '';
      } else {
        this.data.checkbox_1 = 1;
      }
      requestAnimationFrame(this.validate);
    },
    onCheckboxChange2(event) {
      if (!event.target.checked) {
        this.data.checkbox_2 = '';
      } else {
        this.data.checkbox_2 = 1;
      }
      requestAnimationFrame(this.validate);
    },
    trans(key) {
      return translate(key);
    },
    nl2br(str) {
      if (typeof str === 'undefined' || str === null) {
        return '';
      }
      var breakTag = '<br>';
      return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
    }
  },
  mounted() {
    // this.validate();
  },
  watch: {
    data: {
      deep: true,
      handler() {
        this.validate();
      }
    },
    sameAddress(newValue, oldValue) {
      if (newValue !== oldValue) {
        // Wait because the DOM must render the
        // validation providers before we validate
        requestAnimationFrame(this.validate);
      }
    },
    showValidate(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.validate();
      }
    }
  }
}
</script>
<style lang="less">
.radioGroup {
  font-family: FranklinGothicBookITC;

  .radio-button-description {
    font-family: FranklinGothicBookITC;
    font-size: 18px;
  }

  .span-white-description {
    font-family: FranklinGothicBookITC;

    input[type="radio"] + label > span {
      top: 12px;
    }

    label {
      font-size: 20px;
      font-weight: 600;
    }
  }

  .span-simple {
    font-family: FranklinGothicBookITC;

    input[type="radio"] + label > span {
      top: 2px;
    }

    label {
      font-size: 20px;
      font-weight: 600;
    }
  }
}

@media screen and (max-width: 599px) {
  .radioGroup {
    .radio-button-description {
      font-size: 14px;
    }

    .span-white-description {
      font-family: FranklinGothicBookITC;

     

      label {
        font-size: 16px;
      }
    }
  }
}

.color-order-billing-title {
  display: block;
  width: 100%;
  margin-top: 20px;
  margin-bottom: 10px;
  font-family: "FranklinGothicBookITC";
  font-style: normal;
  font-weight: normal;
  font-size: 31px;
}

.color-order-billing-subtitle {
  display: block;
  width: 100%;
  font-family: FranklinGothicBookITC;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
}

.color-sample-checkout {
  .row > div {
    padding: 0 12px;
  }

  .sample_order_next_button.type-1:not(.color-sample-checkout-active) {
    background: #E4E4E4 !important;
  }

  .color-order-basket-title {
    font-family: "FranklinGothicBookITC";
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
  }

  .color-sample-input {
    width: 100%;
    padding: 8px;
    font-family: "FranklinGothicBookITC";
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    align-items: center;
    color: #757575;
    border: solid 1px #D2D1CF;
    margin-bottom: 16px;
  }

  .color-sample-input-error {
    border: 1px solid #E20019;
  }

  .color-order-billing-label-error {
    text-decoration: underline;
    text-decoration-color: #E20019;;
  }

  .color-order-billing-label {
    font-family: FranklinGothicBookITC;
    font-style: normal;
    font-weight: normal;
    font-size: 19px;
    align-items: center;
    color: #000000;
    margin-left: 20px;
  }

  .color-order-billing-radio-container {
    position: relative;
    margin-bottom: 10px;
  }

  .color-order-billing-radio {
    position: absolute;
    top: 8px;
  }

  .checkboxGroup {
    .form-check-label {
      position: relative;
      width: 100%;
      display: block;
    }

    .form-check-label input[type="checkbox"] {
      margin: 0;
      left: 0;
      -webkit-appearance: none;
      appearance: none;
      pointer-events: none;
      left: -9999px;
      border: none;
      opacity: 0;
    }

    .form-check-label span {
      width: 20px;
      height: 20px;
      border: 1px solid #D2D1CF;
      display: block;
      position: absolute;
      left: 0;
      top: 2px;
    }

    .form-check-label span.check-span {
      cursor: pointer;
    }

    .form-check-label span.checkbox-text {
      height: auto;
      font-weight: 600;
      width: 100%;
      margin-left: 0px;
      border: none;
      position: relative;
      top: 0px;
      font-size: 18px;
      font-family: "FranklinGothicBookITC";
      line-height: 24px;
      margin: 0;
      display: block;
      cursor: pointer;
    }
    /*
    .form-check-label.checked span.checkbox-text {
      color: #DF0A25;
    }
    */
    .form-check-label span.checkbox-text:before {
      display: none !important;
    }

    .form-check-label input + span::before,
    .form-check-label input + label.error + span::before {
      line-height: 18px;
      position: absolute;
    }

    .form-check-label input:checked + span::before,
    .form-check-label input:checked + label.error + span::before {
      content: "\F12C";
      color: #DF0A25;
    }

    .form-check-label input.error[data-dirty="true"] + span,
    .form-check-label input.error[data-dirty="true"] + label.error + span {
      border-color: #DF0A25 !important;
    }

  }

}
</style>